import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactGA from 'react-ga4';
import ScrollToTop from './ScrollToTop';

import PaymentSuccess from './PaymentSuccess'
import BIKE from './BIKE';
import LANDING from './LANDING';
import FAQ from './Faq';
import CLAIM from './Claims';

ReactGA.initialize([{
	trackingId: 'G-PYBCPW4GZZ',
	debug: true,
	gtagOptions: {
		cookieDomain: 'auto',
 		allowAdFeatures: true
	},

}]);
ReactGA.event({
  category: "your category",
  action: "your action",
  label: "your label", // optional
  value: 99, // optional, must be a number
  nonInteraction: true, // optional, true/false
  transport: "xhr", // optional, beacon/xhr/image
});

export default function App() {
	useEffect(() => {
        //ReactGA.pageview(window.location.pathname + window.location.search);
ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search,title:"Bicycle"});

 });


	return (
		<Router>
			<div id="content-wrapper" className="container-fluid">
				<nav className="navbar navbar-light navbar-expand-lg bg-transparent">
					<div className="navbar-brand d-flex clickable">
						<a  href="https://instapol.my/"><img className="instapol-logo" src="../images/new-logo-white.png" alt="Howden Insurance Brokers Sdn Bhd" loading="lazy" /></a>
					</div>
					<button className="navbar-toggler text-white border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
						<i className="fas fa-bars" />
					</button>
					<div className="collapse navbar-collapse" id="navbar">
						<ul className="navbar-nav ms-auto">
							<li className="nav-item">
								<a className="nav-link text-white fw-bold" href="https://instapol.my/">Home</a>
							</li>
								<li class="nav-item dropdown">
									<a class="nav-link dropdown-toggle text-white fw-bold" href="#" id="productDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
										Our Products
									</a>
									<ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/motor"}>Motor Insurance</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/bike"}>Bicycle Insurance</a></li>
										<li><a className="dropdown-item" href={process.env.MIX_INSTAPOL_DOMAIN + "/travel"}>Travel Insurance</a></li>
									</ul>
								</li>

							<li className="nav-item dropdown">
								<a className="nav-link dropdown-toggle text-white fw-bold" id="aboutDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
									About Us
								</a>
								<ul className="dropdown-menu" aria-labelledby="aboutDropdown">
									<li><a className="dropdown-item" href="https://instapol.my/about-us">About instaPol</a></li>
									<li><a className="dropdown-item" href="https://instapol.my/privacy-policy">Privacy Policy</a></li>
									<li><a className="dropdown-item" href="https://instapol.my/refund-policy">Refund Policy</a></li>
									<li><a className="dropdown-item" href="https://instapol.my/cookie-policy">Cookies Policy</a></li>
									<li><a className="dropdown-item" href="https://instapol.my/term-of-use">Terms and Conditions</a></li>
								</ul>
							</li>
							<li className="nav-item">
								<a className="btn btn-outline-primary text-white fw-bold" href="/Faq">FAQs</a>
							</li>
							<li className="nav-item">
								<a className="btn btn-outline-primary text-white fw-bold" href="/Claims">Contact Us & Claims</a>
							</li>
						</ul>
					</div>
				</nav>
				<ScrollToTop />
				<Switch>
					<Route exact path="/LANDING">
						<LANDING />
					</Route>

					<Route exact path="/BIKE">
						<BIKE />
					</Route>
					
					<Route exact path="/success">
						<PaymentSuccess />
					</Route>

					<Route exact path="/Faq">
						<FAQ />
					</Route>

					<Route exact path="/Claims">
						<CLAIM />
					</Route>
				</Switch>
				<section id="footer" className="mt-4">
					<div className="row">
						<div className="col-12">
							<footer id="home-footer">
								<div className="container">
									<div className="row">
										<div className="col-7">
											<a href="https://instapol.my">
												<img src="../images/new-logo-02.png" id="instapol-logo" alt="Instapol" width={150} loading="lazy" />
											</a>
											<p className="d-flex justify-content-between mt-3">
												<div className="row">
													<div className="col-12 col-sm-3 border-end">
														<a className="btn btn-link" href="https://www.howdengroup.com/my-en/privacy-and-data-protection">
															Privacy Notice
														</a>
													</div>
													<div className="col-12 col-sm-3 border-end">
														<a className="btn btn-link" href="https://instapol.my/refund-policy">
															Refund Policy
														</a>
													</div>
													<div className="col-12 col-sm-3 border-end">
														<a className="btn btn-link" href="https://www.howdengroup.com/my-en/terms-and-conditions">
															Terms &amp; Conditions
														</a>
													</div>
													<div className="col-12 col-sm-3">
														<a className="btn btn-link" href="https://www.howdengroup.com/my-en/complaints_handling">
															Complaints Handling and Resolution Guide
														</a>
													</div>

												</div>
											</p>
											<p>Copyright © 2021 Instapol. All rights reserved.</p>
										</div>
										<div className="col-5 text-end">
											<p>Developed and owned by</p>
											<a href="https://www.howdengroup.com/my-en">
												<img src="../images/new-howden-logo-navy.png" id="howden-logo" alt="Howden Insurance Brokers Sdn Bhd" width={200} loading="lazy" />
											</a>
											<p className="mt-3 mb-0">Howden Insurance Brokers Sdn. Bhd. (197801001023)</p>
											<p>Howden Takaful Brokers Sdn. Bhd. (198001010734)</p>
										</div>
									</div>
								</div>
							</footer>
						</div>
					</div>
				</section>
			</div>
		</Router>
	);
}
